<template>
<div class="vtd-root" :style="themePageStyle">
  <nav class="vtd-topbar"><div class="container d-flex align-items-center justify-content-between py-2">
    <div class="d-flex align-items-center" style="gap:12px;">
      <a href="javascript:void(0)" @click="$router.push('/')"><img src="assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;">🩺 Vet Dashboard</span>
    </div>
    <button class="btn btn-sm btn-outline-warning" @click="$router.push('/vets')"><i class="mdi mdi-magnify me-1"></i>Find Vets</button>
  </div></nav>

  <div class="container vtd-container">
    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>
    <div v-else-if="!profile" class="text-center py-5">
      <i class="mdi mdi-stethoscope" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
      <h5 class="mt-3" style="color:var(--fm-h,#F5F0E8);">No Vet Profile</h5>
      <p style="color:var(--fm-s,#6B6356);">Register as a veterinarian to access your dashboard.</p>
      <button class="btn btn-warning mt-2" @click="openRegister"><i class="mdi mdi-plus me-1"></i>Register as Vet</button>
    </div>
    <div v-else>
      <!-- Profile header / status -->
      <div class="vtd-card mb-3 d-flex align-items-center justify-content-between" style="gap:12px;">
        <div class="d-flex align-items-center" style="gap:12px;min-width:0;">
          <div class="vtd-avatar" style="width:48px;height:48px;font-size:18px;">🩺</div>
          <div style="min-width:0;">
            <div style="color:var(--fm-h,#F5F0E8);font-weight:700;font-size:14px;">{{ profile.practice_name || 'Independent Vet' }}</div>
            <div style="color:var(--fm-s,#6B6356);font-size:11px;">KVB: {{ profile.kvb_registration_number }} <span v-if="profile.years_of_experience">· {{ profile.years_of_experience }} yrs</span></div>
            <div style="margin-top:3px;">
              <span class="vtd-status" :class="profile.status==='active' ? 'st-completed' : 'st-cancelled'">{{ profile.status==='active' ? 'Active' : 'Inactive' }}</span>
            </div>
          </div>
        </div>
        <button class="btn btn-sm btn-outline-warning" @click="openEdit"><i class="mdi mdi-pencil me-1"></i>Edit Profile</button>
      </div>

      <div v-if="profile.status!=='active'" class="vtd-alert" style="color:#FF9800;background:rgba(255,152,0,.08);border-color:rgba(255,152,0,.3);margin-bottom:14px;">
        <i class="mdi mdi-pause-circle-outline me-1"></i>Your profile is currently <strong>inactive</strong> — farmers cannot find or book you. Reactivate from Edit Profile.
      </div>

      <!-- Stats -->
      <div class="row g-3 mb-4">
        <div class="col-6 col-md-3"><div class="vtd-stat"><div class="vtd-stat-icon" style="color:#50C878;background:rgba(80,200,120,.1);"><i class="mdi mdi-check-circle"></i></div><div class="vtd-stat-val">{{ stats.totalConsultations }}</div><div class="vtd-stat-lbl">Completed</div></div></div>
        <div class="col-6 col-md-3"><div class="vtd-stat"><div class="vtd-stat-icon" style="color:#FF9800;background:rgba(255,152,0,.1);"><i class="mdi mdi-clock-alert"></i></div><div class="vtd-stat-val">{{ stats.pendingRequests }}</div><div class="vtd-stat-lbl">Pending</div></div></div>
        <div class="col-6 col-md-3"><div class="vtd-stat"><div class="vtd-stat-icon" style="color:#BFA164;background:rgba(191,161,100,.1);"><i class="mdi mdi-cash"></i></div><div class="vtd-stat-val">KES {{ fNum(stats.monthEarnings) }}</div><div class="vtd-stat-lbl">This Month</div></div></div>
        <div class="col-6 col-md-3"><div class="vtd-stat"><div class="vtd-stat-icon" style="color:#FFD700;background:rgba(255,215,0,.1);"><i class="mdi mdi-star"></i></div><div class="vtd-stat-val">{{ Number(stats.avgRating||0).toFixed(1) }}</div><div class="vtd-stat-lbl">Rating ({{ stats.totalReviews }})</div></div></div>
      </div>

      <!-- Tabs -->
      <div class="d-flex gap-2 mb-3 flex-wrap">
        <button v-for="tab in tabs" :key="tab.v" class="vtd-tab" :class="{active:activeTab===tab.v}" @click="activeTab=tab.v">
          {{ tab.l }} <span v-if="tab.v==='upcoming'" class="vtd-tab-badge">{{ upcoming.length }}</span>
        </button>
      </div>

      <!-- Upcoming Appointments -->
      <div v-if="activeTab==='upcoming'">
        <div v-if="!upcoming.length" class="vtd-card text-center py-4">
          <i class="mdi mdi-calendar-blank" style="font-size:36px;color:var(--fm-s,#3A3530);display:block;margin-bottom:8px;"></i>
          <div style="color:var(--fm-s,#6B6356);font-size:13px;">No upcoming appointments</div>
        </div>
        <div v-for="c in upcoming" :key="c.id" class="vtd-card mb-2" @click="$router.push('/vet/consultation/'+c.id)" style="cursor:pointer;">
          <div class="d-flex align-items-center gap-3">
            <div class="vtd-avatar">{{ (c.farmer_name||'F').charAt(0) }}</div>
            <div class="flex-fill">
              <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:13px;">{{ c.farmer_name }}</div>
              <div style="color:var(--fm-m,#A09888);font-size:12px;">{{ c.reason }}</div>
              <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:2px;">
                <span v-if="c.scheduled_date"><i class="mdi mdi-calendar me-1"></i>{{ c.scheduled_date }}</span>
                <span v-if="c.scheduled_time" class="ms-2"><i class="mdi mdi-clock me-1"></i>{{ c.scheduled_time }}</span>
                <span v-if="c.species_name" class="ms-2"><i class="mdi mdi-paw me-1"></i>{{ c.species_name }}</span>
              </div>
            </div>
            <div class="text-end">
              <span class="vtd-status" :class="'st-'+c.status">{{ c.status.replace(/_/g,' ') }}</span>
              <div style="color:#BFA164;font-weight:600;font-size:12px;margin-top:4px;">KES {{ Number(c.fee||0).toLocaleString() }}</div>
            </div>
          </div>
          <div v-if="c.status==='requested'" class="d-flex gap-2 mt-3 pt-2" style="border-top:1px solid var(--fm-br,#1E1E1E);">
            <button v-if="requiresPrepaymentGate(c)" class="btn btn-sm flex-fill" disabled style="background:rgba(255,152,0,.08);border:1px solid rgba(255,152,0,.3);color:#FF9800;cursor:not-allowed;" :title="'Awaiting farmer payment (KES '+fNum(c.fee)+')'">
              <i class="mdi mdi-cash-clock me-1"></i>Awaiting Payment
            </button>
            <button v-else class="btn btn-sm btn-outline-success flex-fill" @click.stop="updateStatus(c.id,'confirmed')"><i class="mdi mdi-check me-1"></i>Accept</button>
            <button class="btn btn-sm btn-outline-danger flex-fill" @click.stop="updateStatus(c.id,'cancelled')"><i class="mdi mdi-close me-1"></i>Decline</button>
          </div>
        </div>
      </div>

      <!-- Recent/Completed -->
      <div v-if="activeTab==='recent'">
        <div v-if="!recent.length" class="vtd-card text-center py-4">
          <div style="color:var(--fm-s,#6B6356);font-size:13px;">No completed consultations yet</div>
        </div>
        <div v-for="c in recent" :key="c.id" class="vtd-card mb-2" @click="$router.push('/vet/consultation/'+c.id)" style="cursor:pointer;">
          <div class="d-flex align-items-center gap-3">
            <div class="vtd-avatar" style="background:rgba(80,200,120,.1);color:#50C878;">✓</div>
            <div class="flex-fill">
              <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:13px;">{{ c.farmer_name }}</div>
              <div style="color:var(--fm-m,#A09888);font-size:12px;">{{ c.reason }}</div>
              <div style="color:var(--fm-s,#6B6356);font-size:10px;">{{ c.species_name }} · {{ formatDate(c.completed_at) }}</div>
            </div>
            <div style="color:#BFA164;font-weight:600;font-size:13px;">KES {{ Number(c.total_charge||c.fee||0).toLocaleString() }}</div>
          </div>
        </div>
      </div>

      <!-- Availability -->
      <div v-if="activeTab==='availability'">
        <div class="vtd-card">
          <h6 style="color:#BFA164;font-size:12px;font-weight:700;text-transform:uppercase;margin-bottom:14px;">Weekly Schedule</h6>
          <div v-for="d in 7" :key="d" class="vtd-avail-row">
            <span class="vtd-avail-day">{{ dayName(d-1) }}</span>
            <span v-if="getAvail(d-1)" style="color:var(--fm-h,#F5F0E8);font-size:12px;">{{ getAvail(d-1).start_time.substring(0,5) }} — {{ getAvail(d-1).end_time.substring(0,5) }}</span>
            <span v-else style="color:var(--fm-s,#6B6356);font-size:12px;">Not available</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ======= Toast ======= -->
  <transition name="vtd-toast-fade">
    <div v-if="toast.show" class="vtd-toast" :class="'toast-'+toast.type">
      <i class="mdi" :class="toast.type==='success' ? 'mdi-check-circle' : 'mdi-alert-circle'"></i>
      <span>{{ toast.msg }}</span>
    </div>
  </transition>

  <!-- ======= Vet Registration Modal ======= -->
  <div v-if="showRegister" class="vtd-overlay" @click.self="closeRegister">
    <div class="vtd-modal">
      <div class="vtd-modal-hd">
        <div>
          <div style="color:#BFA164;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;">{{ editMode ? 'Edit Profile' : 'Vet Onboarding' }}</div>
          <h5 style="color:var(--fm-h,#F5F0E8);margin:2px 0 0;font-size:17px;font-weight:700;">{{ editMode ? 'Update Vet Profile' : 'Register as a Veterinarian' }}</h5>
        </div>
        <button class="vtd-x" @click="closeRegister" aria-label="Close">&times;</button>
      </div>

      <div class="vtd-modal-bd">
        <div v-if="regError" class="vtd-alert">{{ regError }}</div>

        <h6 class="vtd-sect">Credentials</h6>
        <div class="row g-2">
          <div class="col-md-6">
            <label class="vtd-lbl">KVB Registration No. <span style="color:#FF6B6B">*</span></label>
            <input v-model="reg.kvbNumber" class="vtd-inp" placeholder="e.g. KVB/12345" />
          </div>
          <div class="col-md-6">
            <label class="vtd-lbl">Years of Experience</label>
            <input v-model.number="reg.yearsExperience" type="number" min="0" class="vtd-inp" placeholder="e.g. 5" />
          </div>
          <div class="col-12">
            <label class="vtd-lbl">Practice / Clinic Name</label>
            <input v-model="reg.practiceName" class="vtd-inp" placeholder="e.g. Savanna Vet Clinic" />
          </div>
          <div class="col-12">
            <label class="vtd-lbl">Short Bio</label>
            <textarea v-model="reg.bio" rows="2" class="vtd-inp" placeholder="Brief description of your practice, experience & focus areas" />
          </div>
        </div>

        <h6 class="vtd-sect mt-3">Specializations</h6>
        <div class="d-flex flex-wrap gap-2">
          <button type="button" v-for="s in specOptions" :key="s.v"
                  class="vtd-chip" :class="{active: reg.specializations.includes(s.v)}"
                  @click="toggleSpec(s.v)">{{ s.l }}</button>
        </div>

        <h6 class="vtd-sect mt-3">Services Offered</h6>
        <div class="d-flex flex-column gap-2">
          <label class="vtd-check"><input type="checkbox" v-model="reg.isMobile"/> <span>Farm visits (mobile service)</span></label>
          <label class="vtd-check"><input type="checkbox" v-model="reg.offersTelemedicine"/> <span>Telemedicine / video consultations</span></label>
          <label class="vtd-check"><input type="checkbox" v-model="reg.offersEmergency"/> <span>24/7 emergency service</span></label>
        </div>

        <h6 class="vtd-sect mt-3">Booking Policy</h6>
        <label class="vtd-check" style="align-items:flex-start;">
          <input type="checkbox" v-model="reg.requiresPrepayment" style="margin-top:3px;"/>
          <span>
            <strong>Require upfront payment before I accept appointments</strong>
            <div style="color:var(--fm-s,#6B6356);font-size:11px;font-weight:400;margin-top:2px;">Farmers must pay the consultation fee before you can confirm. Protects you from no-shows and time-wasters.</div>
          </span>
        </label>

        <h6 class="vtd-sect mt-3">Fees (KES)</h6>
        <div class="row g-2">
          <div class="col-6 col-md-3">
            <label class="vtd-lbl">Consultation</label>
            <input v-model.number="reg.consultationFee" type="number" min="0" class="vtd-inp" placeholder="0" />
          </div>
          <div class="col-6 col-md-3">
            <label class="vtd-lbl">Farm Visit</label>
            <input v-model.number="reg.farmVisitFee" type="number" min="0" class="vtd-inp" placeholder="0" />
          </div>
          <div class="col-6 col-md-3">
            <label class="vtd-lbl">Telemedicine</label>
            <input v-model.number="reg.telemedicineFee" type="number" min="0" class="vtd-inp" placeholder="0" :disabled="!reg.offersTelemedicine" />
          </div>
          <div class="col-6 col-md-3">
            <label class="vtd-lbl">Emergency</label>
            <input v-model.number="reg.emergencyFee" type="number" min="0" class="vtd-inp" placeholder="0" :disabled="!reg.offersEmergency" />
          </div>
        </div>

        <h6 class="vtd-sect mt-3">Clinic Location</h6>
        <div class="row g-2">
          <div class="col-12" style="position:relative;">
            <label class="vtd-lbl"><i class="mdi mdi-crosshairs-gps me-1" style="color:#BFA164;"></i>Clinic Address — search or pin on map</label>
            <div style="display:flex;gap:8px;">
              <div style="flex:1;position:relative;">
                <input v-model="reg.clinicAddress" type="text" class="vtd-inp" placeholder="Search town, market, area..." @input="onLocSearch" @focus="showLocResults=true" autocomplete="off" style="padding-right:36px;" />
                <i v-if="geoLoading" class="mdi mdi-loading mdi-spin" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);color:var(--fm-s,#6B6356);"></i>
                <i v-else-if="reg.clinicLatitude" class="mdi mdi-check-circle" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);color:#50C878;"></i>
              </div>
              <button type="button" class="vtd-gps-btn" @click="useMyLocation" :disabled="geoLoading" title="Use my current location">
                <i v-if="geoLoading" class="mdi mdi-loading mdi-spin"></i>
                <i v-else class="mdi mdi-crosshairs-gps"></i>
              </button>
            </div>
            <div v-if="showLocResults && locResults.length > 0" class="vtd-loc-dropdown">
              <div v-for="(loc, li) in locResults" :key="li" class="vtd-loc-item" @click="pickLocation(loc)">
                <i class="mdi mdi-map-marker" style="color:#BFA164;flex-shrink:0;margin-top:2px;"></i>
                <div>
                  <div style="font-size:13px;color:var(--fm-h,#F5F0E8);">{{ loc.display_name }}</div>
                  <div style="font-size:11px;color:var(--fm-s,#6B6356);">{{ loc.area }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="vtd-map-container">
              <div id="vetClinicMap" class="vtd-map"></div>
              <div class="vtd-map-hint"><i class="mdi mdi-gesture-tap me-1"></i>Tap the map to pin your clinic location</div>
            </div>
            <div v-if="reg.clinicLatitude && reg.clinicLongitude" style="font-size:11px;color:#50C878;margin-top:6px;">
              <i class="mdi mdi-check-circle me-1"></i>Location set
              <span style="color:var(--fm-s,#6B6356);">({{ Number(reg.clinicLatitude).toFixed(4) }}, {{ Number(reg.clinicLongitude).toFixed(4) }})</span>
            </div>
          </div>

          <div class="col-md-6">
            <label class="vtd-lbl">Service Radius (km)</label>
            <input v-model.number="reg.serviceRadiusKm" type="number" min="1" class="vtd-inp" placeholder="50" />
          </div>
        </div>
      </div>

      <div class="vtd-modal-ft">
        <button v-if="editMode && profile && profile.status==='active'" class="btn btn-sm btn-outline-danger me-auto" @click="deactivateProfile" :disabled="registering">
          <i class="mdi mdi-pause-circle-outline me-1"></i>Deactivate
        </button>
        <button v-else-if="editMode && profile && profile.status!=='active'" class="btn btn-sm btn-outline-success me-auto" @click="reactivateProfile" :disabled="registering">
          <i class="mdi mdi-play-circle-outline me-1"></i>Reactivate
        </button>
        <button class="btn btn-sm btn-outline-secondary" @click="closeRegister" :disabled="registering">Cancel</button>
        <button class="btn btn-sm btn-warning" @click="submitRegistration" :disabled="registering">
          <span v-if="registering" class="spinner-border spinner-border-sm me-1"></span>
          <i v-else class="mdi mdi-check-circle me-1"></i>
          {{ registering ? 'Saving…' : (editMode ? 'Save Changes' : 'Submit Registration') }}
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] .vtd-root{background:#F7F5F2!important}
html[data-theme="light"] .vtd-topbar{background:rgba(255,255,255,.95)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .vtd-card,.vtd-stat{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .vtd-tab{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#555!important}
html[data-theme="light"] .vtd-tab.active{background:rgba(191,161,100,.1)!important;border-color:#BFA164!important;color:#BFA164!important}
</style>

<style scoped>
.vtd-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh}
.vtd-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.vtd-container{padding-top:80px;padding-bottom:60px;max-width:900px}
.vtd-stat{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px;display:flex;align-items:center;gap:12px}
.vtd-stat-icon{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0}
.vtd-stat-val{font-size:18px;font-weight:700;color:var(--fm-h,#F5F0E8)}
.vtd-stat-lbl{font-size:10px;color:var(--fm-s,#6B6356)}
.vtd-tab{padding:8px 16px;border-radius:20px;border:1px solid var(--fm-br,#1E1E1E);background:var(--fm-bg1,#141414);color:var(--fm-m,#A09888);font-size:12px;cursor:pointer;transition:all .2s}
.vtd-tab.active{background:rgba(191,161,100,.1);border-color:#BFA164;color:#BFA164;font-weight:600}
.vtd-tab-badge{background:rgba(255,107,107,.15);color:#FF6B6B;padding:1px 6px;border-radius:8px;font-size:10px;margin-left:4px}
.vtd-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px}
.vtd-avatar{width:40px;height:40px;border-radius:50%;background:var(--fm-bg3,#1E1E1E);display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:700;color:#BFA164;flex-shrink:0}
.vtd-status{font-size:10px;font-weight:600;padding:2px 8px;border-radius:8px;text-transform:capitalize}
.st-requested{background:rgba(255,152,0,.1);color:#FF9800}
.st-confirmed{background:rgba(79,195,247,.1);color:#4FC3F7}
.st-in_progress{background:rgba(191,161,100,.1);color:#BFA164}
.st-completed{background:rgba(80,200,120,.1);color:#50C878}
.st-cancelled{background:rgba(255,107,107,.1);color:#FF6B6B}
.vtd-avail-row{display:flex;align-items:center;justify-content:space-between;padding:8px 0;border-bottom:1px solid var(--fm-br,#1A1A1A)}
.vtd-avail-row:last-child{border-bottom:none}
.vtd-avail-day{color:var(--fm-h,#F5F0E8);font-weight:600;font-size:12px;min-width:90px}

/* Register modal */
.vtd-overlay{position:fixed;inset:0;background:rgba(0,0,0,.75);z-index:500;display:flex;align-items:center;justify-content:center;padding:16px;overflow-y:auto}
.vtd-modal{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;width:100%;max-width:620px;max-height:92vh;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,.5)}
.vtd-modal-hd{display:flex;align-items:flex-start;justify-content:space-between;padding:18px 20px;border-bottom:1px solid var(--fm-br,#1E1E1E)}
.vtd-modal-bd{padding:18px 20px;overflow-y:auto;flex:1}
.vtd-modal-ft{display:flex;justify-content:flex-end;gap:8px;padding:14px 20px;border-top:1px solid var(--fm-br,#1E1E1E)}
.vtd-x{background:transparent;border:none;color:var(--fm-m,#A09888);font-size:26px;line-height:1;cursor:pointer;padding:0 4px}
.vtd-x:hover{color:#FF6B6B}
.vtd-sect{color:#BFA164;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;margin:0 0 8px}
.vtd-lbl{display:block;color:var(--fm-m,#A09888);font-size:11px;font-weight:600;margin-bottom:4px}
.vtd-inp{width:100%;padding:8px 10px;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:6px;color:var(--fm-h,#F5F0E8);font-size:13px;outline:none;transition:border-color .15s}
.vtd-inp:focus{border-color:#BFA164}
.vtd-inp:disabled{opacity:.5;cursor:not-allowed}
.vtd-chip{padding:6px 12px;border-radius:16px;border:1px solid var(--fm-br,#1E1E1E);background:var(--fm-bg2,#0F0F0F);color:var(--fm-m,#A09888);font-size:12px;cursor:pointer;transition:all .15s}
.vtd-chip.active{background:rgba(191,161,100,.12);border-color:#BFA164;color:#BFA164;font-weight:600}
.vtd-check{display:flex;align-items:center;gap:8px;color:var(--fm-h,#F5F0E8);font-size:13px;cursor:pointer;user-select:none}
.vtd-check input{accent-color:#BFA164;width:16px;height:16px}
.vtd-alert{background:rgba(255,107,107,.1);border:1px solid rgba(255,107,107,.3);color:#FF6B6B;padding:8px 12px;border-radius:6px;font-size:12px;margin-bottom:12px}

/* Location search + map */
.vtd-gps-btn{width:40px;height:40px;display:flex;align-items:center;justify-content:center;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:6px;color:#BFA164;cursor:pointer;transition:all .15s;flex-shrink:0}
.vtd-gps-btn:hover:not(:disabled){background:rgba(191,161,100,.12);border-color:#BFA164}
.vtd-gps-btn:disabled{opacity:.5;cursor:not-allowed}
.vtd-loc-dropdown{position:absolute;left:0;right:48px;top:100%;background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:6px;max-height:240px;overflow-y:auto;z-index:10;box-shadow:0 8px 20px rgba(0,0,0,.4);margin-top:4px}
.vtd-loc-item{display:flex;align-items:flex-start;gap:8px;padding:10px 12px;cursor:pointer;border-bottom:1px solid var(--fm-br,#1A1A1A)}
.vtd-loc-item:hover{background:rgba(191,161,100,.08)}
.vtd-loc-item:last-child{border-bottom:none}
.vtd-map-container{position:relative;border-radius:8px;overflow:hidden;border:1px solid var(--fm-br,#1E1E1E)}
.vtd-map{width:100%;height:260px}
.vtd-map-hint{position:absolute;bottom:8px;left:8px;background:rgba(20,20,20,.85);color:#F5F0E8;font-size:11px;padding:4px 8px;border-radius:4px;pointer-events:none;backdrop-filter:blur(4px)}

/* Toast */
.vtd-toast{position:fixed;top:24px;left:50%;transform:translateX(-50%);z-index:900;display:flex;align-items:center;gap:10px;padding:12px 18px;border-radius:10px;font-size:13px;font-weight:600;box-shadow:0 10px 30px rgba(0,0,0,.4);max-width:92vw}
.vtd-toast .mdi{font-size:20px}
.vtd-toast.toast-success{background:#1E3A2B;border:1px solid #50C878;color:#9FE8B5}
.vtd-toast.toast-error{background:#3A1E1E;border:1px solid #FF6B6B;color:#FFB5B5}
.vtd-toast-fade-enter-active,.vtd-toast-fade-leave-active{transition:all .25s ease}
.vtd-toast-fade-enter-from{opacity:0;transform:translate(-50%,-12px)}
.vtd-toast-fade-leave-to{opacity:0;transform:translate(-50%,-12px)}
</style>

<script>
/* eslint-disable */
import { executeJson, flocker } from "@/api";
export default {
  name: "VetDashboard",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,loading:true,
    profile:null,stats:{},upcoming:[],recent:[],availability:[],
    activeTab:'upcoming',showRegister:false,registering:false,regError:'',editMode:false,
    locResults:[],showLocResults:false,locSearchTimer:null,geoLoading:false,
    mapInstance:null,mapMarker:null,
    toast:{show:false,msg:'',type:'success'},toastTimer:null,
    reg:{kvbNumber:'',practiceName:'',bio:'',yearsExperience:null,specializations:[],isMobile:true,offersTelemedicine:false,offersEmergency:false,requiresPrepayment:false,consultationFee:null,farmVisitFee:null,telemedicineFee:null,emergencyFee:null,clinicAddress:'',clinicLatitude:null,clinicLongitude:null,serviceRadiusKm:50},
    specOptions:[
      {v:'large_animals',l:'Large Animals'},
      {v:'small_animals',l:'Small Animals'},
      {v:'poultry',l:'Poultry'},
      {v:'dairy',l:'Dairy'},
      {v:'reproduction',l:'Reproduction / AI'},
      {v:'surgery',l:'Surgery'},
      {v:'pathology',l:'Pathology'},
      {v:'nutrition',l:'Nutrition'}
    ],
    tabs:[{v:'upcoming',l:'Upcoming'},{v:'recent',l:'Completed'},{v:'availability',l:'Availability'}]
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'}
  },
  mounted(){
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);
    this.darkMode=t!=='light';
    this.syncTheme();this.themeObserver=new MutationObserver(this.syncTheme);
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    this.loadDashboard();
  },
  beforeUnmount(){if(this.themeObserver)this.themeObserver.disconnect();if(this.toastTimer)clearTimeout(this.toastTimer);if(this.locSearchTimer)clearTimeout(this.locSearchTimer);},
  methods:{
    syncTheme(){this.darkMode=document.documentElement.getAttribute('data-theme')!=='light'},
    requiresPrepaymentGate(c){
      return this.profile && String(this.profile.requires_prepayment)==='1' && (c.payment_status||'pending')!=='paid';
    },
    fNum(n){return Number(n||0).toLocaleString()},
    dayName(d){return['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'][d]||''},
    formatDate(d){if(!d)return'';return new Date(d).toLocaleDateString('en-KE',{day:'numeric',month:'short'})},
    getAvail(day){return this.availability.find(function(a){return parseInt(a.day_of_week)===day})},
    async loadDashboard(){
      this.loading=true;
      var userId=sessionStorage.getItem('userId');
      if(!userId){this.$router.push('/login');return}
      try{
        var r=await executeJson({function:'getVetDashboard',vetUserId:userId},flocker);
        if(r.data&&r.data.success&&r.data.data){
          this.profile=r.data.data.profile;
          this.stats=r.data.data.stats||{};
          this.upcoming=r.data.data.upcoming||[];
          this.recent=r.data.data.recent||[];
          this.availability=r.data.data.availability||[];
        }
      }catch(e){console.error(e)}
      this.loading=false;
    },
    async updateStatus(consultationId,status){
      try{
        var actorUserId=sessionStorage.getItem('userId')||'';
        var payload={function:'updateConsultation',consultationId:consultationId,status:status,actorUserId:actorUserId};
        if(status==='cancelled'){
          var reason=prompt('Reason for cancellation (optional):','');
          if(reason!==null) payload.cancellationReason=reason;
        }
        var r=await executeJson(payload,flocker);
        if(r.data&&r.data.success){
          await this.loadDashboard();
          var labels={confirmed:'Appointment accepted — farmer notified',cancelled:'Appointment declined — farmer notified',en_route:'Marked on the way',in_progress:'Consultation started',completed:'Consultation completed',no_show:'Marked as no-show'};
          this.showToast(labels[status]||'Status updated','success');
        }else{
          this.showToast((r.data&&r.data.message)||'Failed to update status','error');
        }
      }catch(e){this.showToast('Network error — please try again','error');}
    },
    toggleSpec(v){
      var i=this.reg.specializations.indexOf(v);
      if(i>=0) this.reg.specializations.splice(i,1); else this.reg.specializations.push(v);
    },
    showToast(msg, type){
      if(this.toastTimer)clearTimeout(this.toastTimer);
      this.toast={show:true,msg:msg,type:type||'success'};
      var self=this;
      this.toastTimer=setTimeout(function(){self.toast.show=false;},3000);
    },
    openRegister(){
      this.editMode=false;
      this.reg={kvbNumber:'',practiceName:'',bio:'',yearsExperience:null,specializations:[],isMobile:true,offersTelemedicine:false,offersEmergency:false,requiresPrepayment:false,consultationFee:null,farmVisitFee:null,telemedicineFee:null,emergencyFee:null,clinicAddress:'',clinicLatitude:null,clinicLongitude:null,serviceRadiusKm:50};
      this.regError='';this.locResults=[];this.showLocResults=false;
      this.showRegister=true;
      var self=this;this.$nextTick(function(){self.initMap();});
    },
    openEdit(){
      if(!this.profile)return;
      var p=this.profile;
      var specs=[];try{specs=typeof p.specializations==='string'?JSON.parse(p.specializations||'[]'):(p.specializations||[]);}catch(e){specs=[];}
      this.editMode=true;
      this.reg={
        kvbNumber:p.kvb_registration_number||'',
        practiceName:p.practice_name||'',
        bio:p.bio||'',
        yearsExperience:p.years_of_experience?Number(p.years_of_experience):null,
        specializations:Array.isArray(specs)?specs:[],
        isMobile:String(p.is_mobile)==='1',
        offersTelemedicine:String(p.offers_telemedicine)==='1',
        offersEmergency:String(p.offers_emergency)==='1',
        requiresPrepayment:String(p.requires_prepayment)==='1',
        consultationFee:p.consultation_fee?Number(p.consultation_fee):null,
        farmVisitFee:p.farm_visit_fee?Number(p.farm_visit_fee):null,
        telemedicineFee:p.telemedicine_fee?Number(p.telemedicine_fee):null,
        emergencyFee:p.emergency_fee?Number(p.emergency_fee):null,
        clinicAddress:p.clinic_address||'',
        clinicLatitude:p.clinic_latitude?Number(p.clinic_latitude):null,
        clinicLongitude:p.clinic_longitude?Number(p.clinic_longitude):null,
        serviceRadiusKm:p.service_radius_km?Number(p.service_radius_km):50
      };
      this.regError='';this.locResults=[];this.showLocResults=false;
      this.showRegister=true;
      var self=this;this.$nextTick(function(){self.initMap();});
    },
    closeRegister(){
      if(this.registering)return;
      this.showRegister=false;this.regError='';this.editMode=false;
      this.locResults=[];this.showLocResults=false;
      if(this.mapInstance){try{this.mapInstance.remove();}catch(e){}this.mapInstance=null;this.mapMarker=null;}
      this.reg={kvbNumber:'',practiceName:'',bio:'',yearsExperience:null,specializations:[],isMobile:true,offersTelemedicine:false,offersEmergency:false,requiresPrepayment:false,consultationFee:null,farmVisitFee:null,telemedicineFee:null,emergencyFee:null,clinicAddress:'',clinicLatitude:null,clinicLongitude:null,serviceRadiusKm:50};
    },
    async submitRegistration(){
      this.regError='';
      var userId=sessionStorage.getItem('userId');
      if(!userId){this.$router.push('/login');return}
      if(!this.reg.kvbNumber||!String(this.reg.kvbNumber).trim()){this.regError='KVB registration number is required';return}
      this.registering=true;
      var payload={
        function:this.editMode?'updateVetProfile':'registerVet',
        userId:userId,
        kvbNumber:String(this.reg.kvbNumber).trim(),
        practiceName:this.reg.practiceName||'',
        bio:this.reg.bio||'',
        yearsExperience:this.reg.yearsExperience||'',
        specializations:JSON.stringify(this.reg.specializations||[]),
        serviceRadiusKm:this.reg.serviceRadiusKm||50,
        consultationFee:this.reg.consultationFee||'',
        farmVisitFee:this.reg.farmVisitFee||'',
        telemedicineFee:this.reg.offersTelemedicine?(this.reg.telemedicineFee||''):'',
        emergencyFee:this.reg.offersEmergency?(this.reg.emergencyFee||''):'',
        isMobile:this.reg.isMobile?'1':'0',
        offersTelemedicine:this.reg.offersTelemedicine?'1':'0',
        offersEmergency:this.reg.offersEmergency?'1':'0',
        requiresPrepayment:this.reg.requiresPrepayment?'1':'0',
        clinicAddress:this.reg.clinicAddress||'',
        clinicLatitude:this.reg.clinicLatitude||'',
        clinicLongitude:this.reg.clinicLongitude||''
      };
      var wasEdit=this.editMode;
      try{
        var r=await executeJson(payload,flocker);
        if(r.data&&r.data.success){
          await this.loadDashboard();
          this.registering=false;
          this.closeRegister();
          this.showToast(wasEdit?'Profile updated successfully':'Vet profile created successfully','success');
          return;
        }else{
          this.regError=(r.data&&r.data.message)||(wasEdit?'Update failed':'Registration failed');
        }
      }catch(e){
        this.regError=(e.response&&e.response.data&&e.response.data.message)||'Network error. Please try again.';
      }
      this.registering=false;
    },
    async deactivateProfile(){
      if(!confirm('Deactivate your vet profile? Farmers will no longer see you in search results until you reactivate.'))return;
      await this.setProfileStatus('inactive');
    },
    async reactivateProfile(){
      await this.setProfileStatus('active');
    },
    async setProfileStatus(status){
      var userId=sessionStorage.getItem('userId');
      if(!userId)return;
      this.registering=true;this.regError='';
      try{
        var r=await executeJson({function:'updateVetProfile',userId:userId,status:status},flocker);
        if(r.data&&r.data.success){
          await this.loadDashboard();
          this.registering=false;
          this.closeRegister();
          this.showToast(status==='active'?'Profile reactivated — you are visible to farmers again':'Profile deactivated','success');
          return;
        }else{
          this.regError=(r.data&&r.data.message)||'Failed to update status';
        }
      }catch(e){
        this.regError=(e.response&&e.response.data&&e.response.data.message)||'Network error';
      }
      this.registering=false;
    },

    // ===== LOCATION SEARCH (Nominatim) =====
    onLocSearch(){
      if(this.locSearchTimer)clearTimeout(this.locSearchTimer);
      var self=this;var q=String(this.reg.clinicAddress||'').trim();
      if(q.length<3){this.locResults=[];this.showLocResults=false;return;}
      this.locSearchTimer=setTimeout(function(){self.doLocSearch(q);},400);
    },
    async doLocSearch(q){
      try{
        var url='https://nominatim.openstreetmap.org/search?format=json&countrycodes=ke&limit=6&q='+encodeURIComponent(q);
        var res=await fetch(url);var data=await res.json();
        this.locResults=data.map(function(d){
          var parts=(d.display_name||'').split(',');
          return{display_name:parts.slice(0,3).join(', ').trim(),area:parts.slice(1,4).join(', ').trim(),lat:d.lat,lon:d.lon};
        });
        this.showLocResults=true;
      }catch(e){this.locResults=[];}
    },
    pickLocation(loc){
      this.reg.clinicLatitude=Number(loc.lat);
      this.reg.clinicLongitude=Number(loc.lon);
      this.reg.clinicAddress=loc.display_name;
      this.showLocResults=false;
      this.updatePin(Number(loc.lat),Number(loc.lon));
    },
    useMyLocation(){
      if(!navigator.geolocation)return;
      this.geoLoading=true;var self=this;
      navigator.geolocation.getCurrentPosition(
        function(pos){
          var lat=pos.coords.latitude,lon=pos.coords.longitude;
          self.reg.clinicLatitude=lat;self.reg.clinicLongitude=lon;
          self.geoLoading=false;
          self.updatePin(lat,lon);
          self.reverseGeocode(lat,lon);
        },
        function(){self.geoLoading=false;},
        {enableHighAccuracy:true,timeout:10000}
      );
    },
    reverseGeocode(lat,lon){
      var self=this;
      fetch('https://nominatim.openstreetmap.org/reverse?format=json&lat='+lat+'&lon='+lon)
        .then(function(r){return r.json();})
        .then(function(d){
          if(d&&d.display_name){
            var parts=d.display_name.split(',');
            self.reg.clinicAddress=parts.slice(0,3).join(',').trim();
          }
        }).catch(function(){});
    },
    loadLeaflet(cb){
      if(window.L){cb();return;}
      var css=document.createElement('link');
      css.rel='stylesheet';css.href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(css);
      var js=document.createElement('script');
      js.src='https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      js.onload=cb;
      document.head.appendChild(js);
    },
    initMap(){
      var self=this;
      this.loadLeaflet(function(){
        self.$nextTick(function(){
          var el=document.getElementById('vetClinicMap');
          if(!el)return;
          if(self.mapInstance){self.mapInstance.invalidateSize();return;}
          var lat=Number(self.reg.clinicLatitude)||-1.2921;
          var lon=Number(self.reg.clinicLongitude)||36.8219;
          var zoom=self.reg.clinicLatitude?14:7;
          self.mapInstance=L.map('vetClinicMap',{zoomControl:true,attributionControl:false}).setView([lat,lon],zoom);
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{maxZoom:18}).addTo(self.mapInstance);
          self.mapInstance.on('click',function(e){
            self.reg.clinicLatitude=e.latlng.lat;
            self.reg.clinicLongitude=e.latlng.lng;
            self.updatePin(e.latlng.lat,e.latlng.lng);
            self.reverseGeocode(e.latlng.lat,e.latlng.lng);
          });
          if(self.reg.clinicLatitude&&self.reg.clinicLongitude){
            self.updatePin(Number(self.reg.clinicLatitude),Number(self.reg.clinicLongitude));
          }
          setTimeout(function(){if(self.mapInstance)self.mapInstance.invalidateSize();},200);
        });
      });
    },
    updatePin(lat,lon){
      if(!this.mapInstance||!window.L)return;
      var pinIcon=L.divIcon({
        className:'vtd-pin-icon',
        html:'<div style="background:#BFA164;width:16px;height:16px;border-radius:50%;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,0.5);"></div>',
        iconSize:[16,16],iconAnchor:[8,8]
      });
      if(this.mapMarker){
        this.mapMarker.setLatLng([lat,lon]);
      }else{
        this.mapMarker=L.marker([lat,lon],{icon:pinIcon,draggable:true})
          .addTo(this.mapInstance)
          .bindTooltip('Clinic location',{permanent:false,direction:'top'});
        var self=this;
        this.mapMarker.on('dragend',function(e){
          var pos=e.target.getLatLng();
          self.reg.clinicLatitude=pos.lat;
          self.reg.clinicLongitude=pos.lng;
          self.reverseGeocode(pos.lat,pos.lng);
        });
      }
      this.mapInstance.setView([lat,lon],Math.max(this.mapInstance.getZoom(),13));
    }
  }
};
</script>
